module.exports = __webpack_public_path__ + "img/silver.3c8f4938.png";